// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.messageBubble[data-v-1069cc35]::before {
  content: '';
  border-bottom: 10px solid;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  rotate: 180deg;
  position: absolute;
  top: 0px;
  left: -10px;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(242 245 249 / var(--tw-border-opacity, 1));
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
